import type { FacebookTableViewProps } from 'types/fbTable';
import LoadingSpinner from 'ui/LoadingSpinner';
import FacebookTableAdAccountIdView from './FacebookTable.AdAccountId.View';

const FacebookTableAdAccountId = ({
  metaAdAccount,
  loading
}: Pick<FacebookTableViewProps, 'loading' | 'metaAdAccount'>) => {
  const adAccountId = loading ? <LoadingSpinner size={16} /> : (metaAdAccount?.adAccountId ?? '-');

  return <FacebookTableAdAccountIdView adAccountId={adAccountId} />;
};

export default FacebookTableAdAccountId;
